<template>
<div class = 'voc-list'>
	<!-- <h3>Liste de vocs</h3> -->
	<div>
		<h4 class = "mt-3">Anglais</h4>
		<b-list-group>
		  <b-list-group-item @click.stop="newVoc('english')" class = 'd-none d-lg-block'><strong>nouveau voc...</strong></b-list-group-item>
		  <b-list-group-item button @click.stop="selectVoc(voc)" v-for='voc in english_vocs' :key="voc.name">{{voc.name.replace(/_/g," ")}}</b-list-group-item>

		</b-list-group>
	
		<h4 class = "mt-3">Allemand</h4>
		<b-list-group>
		  <b-list-group-item button @click.stop="newVoc('deutsch')"  class = 'd-none d-lg-block'><strong>nouveau voc...</strong></b-list-group-item>
		  <b-list-group-item button @click.stop="$emit('selectvoc',voc)" v-for='voc in deutsch_vocs' :key="voc.name">{{voc.name.replace(/_/g," ")}}</b-list-group-item>

		</b-list-group>	
	</div>	
</div>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
	name: 'vocList',
	data () {
		return {
			newVocName: '',
			newVocLanguage: ''
		}
	},
	methods: {
		newVoc (language) {
			this.$router.push({path: 'form/new_'+language})
		},
		selectVoc (voc){
			this.$emit('selectvoc',voc)
		}
	},
	computed: {
		...mapGetters({
			vocs: 'vocs' 
		}),
		english_vocs () {
			return _.orderBy(_.uniq(_.filter(this.vocs, v => v.language == 'english')),v => v.name);
		},
		deutsch_vocs () {
			return _.orderBy(_.uniq(_.filter(this.vocs, v => v.language == 'deutsch')),v => v.name);
		}
	}
}
</script>

<style scoped>
</style>